/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'unlocked': {
    viewBox: '0 0 32 32',
    data: `<g><path d="M10,13V9c0-3.3,2.7-6,6-6s6,2.7,6,6c0,0.6,0.4,1,1,1s1-0.4,1-1c0-4.4-3.6-8-8-8S8,4.6,8,9v4H5v18h22V13H10z M25,29H7V15h18V29z"/><path d="M16,25c1.1,0,2-0.9,2-2v-2c0-1.1-0.9-2-2-2s-2,0.9-2,2v2C14,24.1,14.9,25,16,25z"/></g>`
  }
})
